export const CREATE_ONBOARDING = '[Onboarding] Create Onboarding';
export const CREATE_ONBOARDING_SUCCESS =
  '[Onboarding] Create Onboarding Success';
export const CREATE_ONBOARDING_ERROR = '[Onboarding] Create Onboarding Error';
